export default {
      id: "ic-para-ampule-usage",
      viewBox: "0 0 26 26",
      url: "../dist/images/" + "sprite.svg#ic-para-ampule-usage",
      toString: function () {
        return this.url;
      }
    }